import Vue from 'vue'

require('es6-promise').polyfill();

// Component Bootstrap mounted
import App from '@/App.vue'

// Axios
import '@/utils/plugins/Axios.plugin'

// VeeValidate
import '@/utils/plugins/VeeValidator.plugin.js'

// FontAwesome
import '@/utils/plugins/FontAwesome.plugin.js'

// Style files
import 'bootstrap/dist/css/bootstrap.min.css'
import '@/assets/css/styles.css'

Vue.config.productionTip = false

document.addEventListener('DOMContentLoaded', () => {
  new Vue({
    render: h => h(App),
  }).$mount('#app')
});
